import placesListModule from '../placesListModule';

function placeListContainerController() {
  'ngInject';

}

placesListModule.controller('placeListContainerController', placeListContainerController);

export default placeListContainerController;
